<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
                    <c-form-item type="input" label="库存会员" name="user_info"></c-form-item>
                    <c-form-item type="input" label="商品/规格信息" name="product_info"></c-form-item>
                    <c-form-item type="input" label="SKU编码" name="product_sku_code"></c-form-item>
                    <c-form-item type="checkbox" label="变更业务" name="stock_type" :options="stockType"></c-form-item>
                    <c-form-item type="checkbox" label="库存增减" name="income_expenses" :options="incomeExpensesType"></c-form-item>
                    <c-form-item type="input" label="关联订单" name="order_number"></c-form-item>
                    <c-form-item type="datetime" label="发生时间" start-name="start_date" end-name="end_date"></c-form-item>
                </c-form>
			</m-search>
			<c-table ref="table">
                <c-table-column label="库存会员" width="200">
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image v-if="data.head_photo" :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            {{data.nick_name||'--'}}
                            <span v-if="data.user_manage_mobilephone">({{data.user_manage_mobilephone}})</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="250"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="规格名称"
                        name="product_sku_spec"
                        width="90"
                ></c-table-column>

                <c-table-column
                        label="SKU编码"
                        name="product_sku_code"
                        width="150"
                ></c-table-column>

                <c-table-column
                        label="变更业务"
                        name="stock_type"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.stock_type == 1">囤货</span>
                        <span v-if="data.stock_type == 2">后台调整</span>
                        <span v-if="data.stock_type == 3">云仓提货</span>
                        <span v-if="data.stock_type == 4">库存转移</span>
                        <span v-if="data.stock_type == 5">下级囤货</span>
                        <span v-if="data.stock_type == 6">库存回收</span>
                        <span v-if="data.stock_type == -2">订单关闭</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="库存增减"
                        name="income_expenses"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.income_expenses == 2" style="color: red">减少</span>
                        <span v-if="data.income_expenses == 1" style="color: green">增加</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="变更数量"
                        name="product_count"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.income_expenses == 2" style="color: red">{{data.product_count}}</span>
                        <span v-if="data.income_expenses == 1" style="color: green">{{data.product_count}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="变更后库存"
                        name="remain_product_count"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="关联订单"
                        name="order_number"
                        width="150"
                >
                    <template v-slot="{data}">
                        <span v-if="data.order_number">{{data.order_number}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="250"
                >
                    <template v-slot="{data}">
                        <span v-if="data.remark">{{data.remark}}</span>
                        <span v-else-if="data.stock_type == 2">总后台用户【{{data.stock_user_name}}】直接调整云仓库存</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

<!--                <c-table-column-->
<!--                        label="操作人"-->
<!--                        name="stock_user_name"-->
<!--                        width="150"-->
<!--                >-->
<!--                </c-table-column>-->

                <c-table-column
                        label="发生时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>
            </c-table>
		</module>
	</page>
</template>
<script>
	import productInfo from '@/components/public/product_info.vue'
	import memberUserSelector from '@/components/service/member_user_selector.vue'
	export
	default {
	  name: 'm_cloud_stock_log',

	  components: {
			productInfo, memberUserSelector
	  },

	  data() {
		return {
          stockType: [
              {name: '囤货',value: 1},
              {name: '后台调整',value: 2},
              {name: '云仓提货',value: 3},
              {name: '库存转移',value: 4},
              {name: '库存回收',value: 6},
              {name: '下级囤货',value: 5},
              {name: '订单关闭',value: -2}
		  ],
          incomeExpensesType: [
              {name: '库存增加',value: 1},
              {name: '库存减少',value: 2}
		  ],
		}
	  },

	  computed: {
	  },

	  watch: {
	  },

	  mounted() {
		this.$refs.search.search();
	  },

	  methods: {
          searchHandle(data = {}) {
              this.$refs.table.load({
                  url: '/member_user/stock/log/list',
                  data
              });
          }
      }
	}
</script>

<style lang="stylus" scoped>
.tag {
    border-radius: 2px;
    padding: 0 5px;
    margin-left: 6px;
    line-height: 18px;
    color: #fff;
}
</style>